import Component from '@glimmer/component';

import { t } from 'ember-intl';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import EmberTooltip from 'ember-tooltips/components/ember-tooltip';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

interface HiddenIndicatorSignature {
  Args: {
    isVisible: boolean;
    tooltipSide?: 'top' | 'right' | 'bottom' | 'left';
  };
}

export class HiddenIndicator extends Component<HiddenIndicatorSignature> {
  // Getter and setter
  get tooltipSide() {
    return this.args.tooltipSide ?? 'right';
  }

  // Template
  <template>
    {{#if @isVisible}}
      <div class={{(bem)}}>
        {{svgJar 'hide' class=(bem 'icon')}}

        <EmberTooltip
          @text={{t 'ui.hidden_indicator.tooltip'}}
          @side={{this.tooltipSide}}
        />
      </div>
    {{/if}}
  </template>
}
